import React, { useContext, useState } from 'react';
import {TextField, Typography, Grid, Button, Snackbar, Alert} from '@mui/material';
import ContentWrapper from '../../components/box/ContentWrapper';
import { AppState } from '../../types/types';
import { CustomerDataContext } from '../../components/context/CustomerDataProvider';
import LinkedappBackend from '../../services/LinkedappBackend';
import TeaserBanner from '../../components/box/TeaserBanner';

interface Props {
    appState?: AppState
}

const Unscubscription : React.FC<Props> = ({appState}) => {
    const {customer, tenant} = useContext(CustomerDataContext);
    const [reason, setReason] = useState("");
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const unsubscribe = () => {
        setError(false);
        setLoading(true);
        if(customer?.partnerNo) {
            LinkedappBackend.unsubscribe(customer?.partnerNo, customer?.firstname??'', customer?.lastname??'', customer?.email??'', appState?.vermittlerDaten?.name1??'', reason, tenant?.toString()).then(success => {
                setSuccess(success);
                setLoading(false);
                setError(!success);
            }).catch(error => {
                setSuccess(false);
                setError(true);
                setLoading(false);
            });
        }
    }

    return success ? <>
    <TeaserBanner>
        <Typography variant='h1'>Das ist erledigt, {`${customer?.firstname} ${customer?.lastname}`}. <br/>Sie erhalten Ihre Post nun wieder in Papierform.</Typography>
    </TeaserBanner>
    <ContentWrapper appState={{} as AppState}>
        <Grid item xs={12} className="control-block">
                <b>Bitte beachten Sie</b><br/>
                <ul>
                    <li>Die Abmeldung gilt für alle Verträge, die über Ihre Kundenverbindung gekennzeichnet sind.</li>
                    <li>Verträge mit anderen/weiteren Versicherungsnehmern (z.B. Ihr*e Partner*in, Eheleute etc.) müssen ggfls separat abgemeldet werden.</li>
                    <li><b>Bis zur endgültigen Umstellung auf den Papierversand, kann es einen zeitlichen Verzug geben.</b></li>
                    <li>Ihre Dokumente, die Sie bis heute digital erhalten haben, können Sie weiterhin über die Ihnen vorliegende E-Mail-Links aufrufen.<br/>So können Sie diese z.B. noch herunterladen oder abspeichern. Zukünftige Dokumente erhalten Sie jetzt nur noch in Papierform.</li>
                </ul>
            </Grid>
    </ContentWrapper>
    </> : <>
            <TeaserBanner>
                <Typography variant='h1'>{`Guten Tag ${customer?.firstname} ${customer?.lastname},`}</Typography>
                <Typography variant='h1'>{`schade, dass Sie Ihre Post nicht mehr digital erhalten wollen`}</Typography>
            </TeaserBanner>
        <ContentWrapper appState={{} as AppState}>
            <Grid item xs={12} className="control-block">
                <Typography variant='body1' sx={{fontWeight: 'bold'}}>Möchten Sie uns mitteilen, warum Sie sich abmelden?<br/>Bitte teilen Sie uns den Grund Ihrer Abmeldung mit.</Typography>
            </Grid>
            
            <Grid item xs={12} className='control-wrapper'>                    
                <TextField label={""} type="text" value={reason} required={false}
                    placeholder='Ich melde mich ab, weil ...'
                        multiline={true}
                        fullWidth={true}
                        rows={4}
                    onChange={(e) => setReason(e?.target?.value)}  id="unsubscribe_reason" 
                    error={false} helperText={""} size="medium" disabled={false}
                />
            </Grid>
        </ContentWrapper>
        <ContentWrapper appState={{} as AppState}>
            <Grid item xs={12} className="control-block">
                <Typography variant='body1' sx={{fontWeight: 'bold'}}>Bitte beachten Sie:</Typography>
                <ul>
                    <li>Die Abmeldung gilt für alle Verträge, die über Ihre Kundenverbindung gekennzeichnet sind.</li>
                    <li>Verträge mit anderen/weiteren Versicherungsnehmern (z.B. Ihr*e Partner*in, Eheleute etc.) müssen ggfls separat abgemeldet werden.</li>
                </ul>
            </Grid>
        </ContentWrapper>
        <Grid container spacing={3} sx={{marginTop: '1rem'}}>
            <Grid item xs={12} className="control-block" sx={{textAlign: 'right'}}>
                <Button name="save" disabled={loading} onClick={unsubscribe}>Meine Entscheidung speichern</Button>
            </Grid>
        </Grid>
        <Snackbar open={error} autoHideDuration={5000} onClose={() => setError(false)}>
            <Alert onClose={() => setError(false)} severity="error" sx={{ width: '100%' }}>
                Bei der Abmeldung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.
            </Alert>
      </Snackbar>
    </>
}

export default Unscubscription;